import { GlobalContext } from "../GlobalContext";

export class MemoryUtils {
    /**
     * Spojí několik paměťových bloků do jednoho.
     * @param buffers Paměťové bloky které se mají spojit
     */
    public static join(...buffers: BufferSource[]): ArrayBuffer {
        const bytesSum = buffers.reduce((pv, cv) => pv + cv.byteLength, 0);
        const result = new Uint8Array(bytesSum);
        let position = 0;
        for (const buffer of buffers) {
            if (buffer instanceof Uint8Array)
                result.set(buffer, position);
            else if (ArrayBuffer.isView(buffer))
                result.set(new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength), position);
            else
                result.set(new Uint8Array(buffer), position);
            position += buffer.byteLength;
        }
        return result.buffer as ArrayBuffer;
    }

    /**
     * Spojí dvě 32bitové pole
     */
    public static join32bitArrays(buf1: Uint32Array, buf2: Uint32Array): Uint32Array {
        const result = new Uint32Array(buf1.length + buf2.length);
        result.set(buf1);
        result.set(buf2, buf1.length);
        return result;
    }

    /**
     * Převede BufferSource do ArrayBufferu
     * Pokud je zdroj ArrayBufferView (např. new Uint8Array(arrayBuffer, 2, 10)), kde je to jen pohled na část interního ArrayBufferu, tak se z něho udělá výřez do nového paměťového bloku,
     * tak je pořebné zvážit jestli je použití této funkce na daném místě vhodný, nebo by bylo lepší požít přímo ArrayBufferView.
     * @param buffer Zdroj, který chceme převést na ArrayBufferu.
     */
    public static bufferSourceToArrayBuffer(data: BufferSource): ArrayBuffer {
        return (ArrayBuffer.isView(data) ? (data.byteOffset != 0 || data.byteLength != data.buffer.byteLength ? data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength) : data.buffer) : data) as ArrayBuffer;
    }
}

GlobalContext.registerType(MemoryUtils);
